import { ThemeProvider as NextThemesProvider } from 'next-themes';
import { type ThemeProviderProps } from 'next-themes/dist/types';
import React from 'react';
import { TurnkeyProvider } from '@turnkey/sdk-react';
import { TurnKeyAuthProvider } from '@/hooks/auth/turnkey/useTurnKeyAuth';
import { SwapProvider } from './SwapProvider';
export const ThemeProvider = React.forwardRef<HTMLDivElement, ThemeProviderProps>(({
  children,
  ...props
}, _) => <TurnkeyProvider config={{
  rpId: 'localhost',
  apiBaseUrl: process.env.NEXT_PUBLIC_TURNKEY_BASE_URL,
  defaultOrganizationId: process.env.NEXT_PUBLIC_TURNKEY_ORGANIZATION_ID
}}>
      <TurnKeyAuthProvider>
        <SwapProvider>
          <NextThemesProvider {...props}>{children}</NextThemesProvider>
        </SwapProvider>
      </TurnKeyAuthProvider>
    </TurnkeyProvider>);
ThemeProvider.displayName = 'ThemeProvider';